export const NODE_TYPE_KEY_TERM = 'key-term';
